import type {
  FavoriteTreeItem,
  LocalHashtag,
  LocalProjectFolderOpen,
} from '../../../generated';
import { ReactiveMap } from '../../../utils/ReactiveMap';
/**
 * a Map from user ID (string) to an array of favorited project IDs (array of string).
 * we use this to store a local model of favorited projects per user
 *
 * we are persisting this Map in storage with the key `favorited-projects`
 * */
export const favoritedProjects = new ReactiveMap<
  string,
  string[],
  'favorited-projects'
>(`favorited-projects`);

/**
 * A map of Assets that have been favorited.
 * These Assets currently can be:
 * Asset, Folder...
 *
 */
export const favoritedAssets = new ReactiveMap<
  string,
  FavoriteTreeItem[],
  `favorited-assets`
>(`favorited-assets`);

/**
 * A map of which folders are open in a project folder tree
 *
 */
export const openedProjectFolders = new ReactiveMap<
  string,
  LocalProjectFolderOpen[],
  'opened-project-folders'
>(`opened-project-folders`);

export const hashtags = new ReactiveMap<string, LocalHashtag[], `hashtags`>(
  `hashtags`
);
